import { Link } from "react-router-dom";
import { stats } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section className="px-4 md:px-6 lg:px-10 py-14 md:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Text Content */}
          <div className="order-2 lg:order-1">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-accent-500 border border-accent-200 rounded-full px-3 py-1 mb-4">
              About Us
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4">
              Your Trusted Fire Safety{" "}
              <span className="text-primary-500">Partner in Singapore</span>
            </h2>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
              Since 2012, Ezzogenics has been safeguarding commercial, industrial, and 
              residential properties across all 28 districts. Our SCDF-certified engineers deliver 
              comprehensive fire risk assessments, system installations, and compliance consulting 
              that keeps your building and its occupants protected.
            </p>
            <p className="text-foreground-600 text-base leading-relaxed mb-8">
              We hold BizSAFE Level 3 certification and are fully BCA-registered, ensuring every 
              project meets Singapore&apos;s stringent fire safety standards from day one.
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-primary-500 font-semibold text-sm hover:text-primary-600 transition-colors underline underline-offset-4"
            >
              Learn more about our team
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          {/* Right: Images & Stats */}
          <div className="order-1 lg:order-2">
            {/* Stats Row */}
            <div className="grid grid-cols-2 gap-4 mb-6">
              {stats.slice(0, 2).map((stat) => (
                <div key={stat.label} className="text-right">
                  <span className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                    {stat.value}
                  </span>
                  <p className="text-foreground-500 text-xs md:text-sm mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            {/* Image Grid */}
            <div className="grid grid-cols-5 gap-3 md:gap-4">
              <div className="col-span-3 row-span-2">
                <div className="w-full h-64 md:h-80 rounded-2xl overflow-hidden">
                  <img
                    src="https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/a212d4b5-cdd7-48a3-8fd9-6e24f099a795_compressed_009ad0ca-c222-48ba-87db-9f46d2c52c52.webp"
                    alt="Ezzogenics team installing emergency lighting at bus interchange"
                    title="Ezzogenics team installing emergency lighting at bus interchange"
                    className="w-full h-full object-cover"
                    width="600"
                    height="700"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="col-span-2">
                <div className="w-full h-28 md:h-36 rounded-2xl overflow-hidden">
                  <img
                    src="https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/96b20c1a-2bc0-4622-9f53-f48fffb73228_compressed_b478d59c-d423-4e1e-b09e-91443bd3caf2.webp"
                    alt="Ezzogenics technician installing exit sign"
                    title="Ezzogenics technician installing exit sign"
                    className="w-full h-full object-cover"
                    width="400"
                    height="300"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="col-span-2">
                <div className="w-full h-28 md:h-36 rounded-2xl overflow-hidden">
                  <img
                    src="https://storage.readdy-site.link/project_files/bad53886-d0ad-4ee3-acb4-5b763a394fe2/1720140f-234c-4e95-86ec-b8ca419e1fef_compressed_Depositphotos_12381850_l-2015.webp"
                    alt="Fire alarm control panel with green display"
                    title="Professional fire alarm control panel system"
                    className="w-full h-full object-cover"
                    width="400"
                    height="300"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>

            {/* Remaining Stats */}
            <div className="grid grid-cols-2 gap-4 mt-6">
              {stats.slice(2, 4).map((stat) => (
                <div key={stat.label} className="text-right">
                  <span className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                    {stat.value}
                  </span>
                  <p className="text-foreground-500 text-xs md:text-sm mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}